import { supabase } from '@/lib/supabase';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function buildReferralLink(code: string, origin = window.location.origin): string {
  return `${origin}/inscription?ref=${encodeURIComponent(code)}`;
}

export async function findReferrerProfileId(referral: string): Promise<string | null> {
  const trimmed = referral.trim();
  if (!trimmed) return null;

  const { data: byKonan } = await supabase
    .from('profiles')
    .select('id')
    .ilike('konan_id', trimmed)
    .eq('role', 'user')
    .eq('is_active', true)
    .maybeSingle();

  if (byKonan?.id) return byKonan.id;

  if (!UUID_RE.test(trimmed)) return null;

  const { data: byToken } = await supabase
    .from('profiles')
    .select('id')
    .eq('referral_token', trimmed)
    .eq('role', 'user')
    .eq('is_active', true)
    .maybeSingle();

  return byToken?.id ?? null;
}

export async function copyReferralLink(link: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(link);
    return true;
  } catch {
    return false;
  }
}

export async function shareReferralLink(link: string, code: string): Promise<'shared' | 'copied' | 'failed'> {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({
        title: 'ISBD — Inscription',
        text: `Rejoignez ISBD avec mon code parrainage : ${code}`,
        url: link,
      });
      return 'shared';
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') return 'failed';
    }
  }

  return (await copyReferralLink(link)) ? 'copied' : 'failed';
}
